import references__antoni from '../img/references__antoni.jpg';
import references__barbermania from '../img/references__barbermania.jpg';
import references__cafe from '../img/references__cafe.jpg';
import references__firmix from '../img/references__firmix.jpg';
import references__harfa from '../img/references__harfa.jpg';
import references__it from '../img/references__it.jpg';
import references__italier from '../img/references__italier.jpg';
import references__karpis from '../img/references__karpis.jpg';
import references__konzultant from '../img/references__konzultant.jpg';
import references__marplive from '../img/references__marplive.jpg';
import references__roc from '../img/references__roc.jpg';
import references__wealth from '../img/references__wealth.jpg';

const references__list = [
    {
        key: 1,
        title: "Cafe Bunny",
        href: "http://cafe.majernikova-barbora.com/",
        src: references__cafe
    },
    {
        key: 2,
        title: "Barbermania",
        href: "http://barbermania.majernikova-barbora.com/",
        src: references__barbermania
    },
    {
        key: 3,
        title: "Váš konzultant reality",
        href: "http://vk-reality-sablony.snugdev.cz/",
        src: references__konzultant
    },
    {
        key: 4,
        title: "Harfa",
        href: "http://podharfou-sablony.snugdev.cz/",
        src: references__harfa
    },
    {
        key: 5,
        title: "Wealth management",
        href: "http://roc-wm-sablony.snugdev.cz/",
        src: references__wealth
    },
    {
        key: 6,
        title: "Marplive",
        href: "http://marplive.majernikova-barbora.com/",
        src: references__marplive
    },
    {
        key: 7,
        title: "ROC",
        href: "http://roc-crm-sablony.snugdev.cz/",
        src: references__roc
    },
    {
        key: 8,
        title: "Váš IT konzultant",
        href: "http://vitk-sablony.snugdev.cz/",
        src: references__it
    },
    {
        key: 9,
        title: "Antoni",
        href: "https://antoni.cz/",
        src: references__antoni
    },
    {
        key: 10,
        title: "Firmix",
        href: "http://firmix.majernikova-barbora.com/",
        src: references__firmix
    },
    {
        key: 11,
        title: "Karpiš furniture",
        href: "http://karpis.sk/",
        src: references__karpis
    },
    {
        key: 12,
        title: "Italier",
        href: "http://italier.majernikova-barbora.com/",
        src: references__italier
    }
];

export default references__list;
